import { getEnumNameById } from '@modules/api-core'
import type { TEnumItem } from '@modules/types'

export const formatRetailPrice = (
    price: number | null,
    currency: number | null,
    enums: TEnumItem[],
) => {
    if (price === null) return undefined
    if (currency === null) return String(price)
    const symbol: Record<string, string> = { 'US Dollar': '$', 'British Pound': '£', Euro: '€' }
    const name = getEnumNameById(enums, 'request_currency', currency)
    return `${symbol[name] ?? ''}${price}`
}
